module.exports = __webpack_public_path__ + "static/report-3be5eae5542ad1a2699b6b29653d3a31.png";